export { RegistrationInput as default } from "./RegistrationInput";
